import { Form, Input, Modal } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import withStyles from 'react-jss';
import useInput from 'src/hooks/form/useInput';
import { createStyles } from 'src/hooks/useStyles';
import { StylesProps } from 'src/Library/Types';

const styles = createStyles((theme) => ({
  modal: {
    position: 'absolute',
    right: 16,
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  content: {
    padding: 15,
    '& .ant-tabs-content': {
      padding: 15,
      border: '1px solid #0000000d',
      marginTop: -3,
      height: 330,
      overflow: 'overlay',
    },
  }
}));

interface SEBidSelectionReasonModalProps
  extends FormComponentProps<any>,
  StylesProps<ReturnType<typeof styles>> {
  handleClose: (refresh?: boolean) => Promise<void>;
  visible: boolean;
  handleSubmit: (selectionReason: string) => void;
}

const SEBidSelectionReasonModal: React.FC<SEBidSelectionReasonModalProps> = ({
  form,
  classes,
  handleClose,
  handleSubmit,
  visible,
}) => {
  const selectionReason = useInput({
    form,
    disabled: false,
    visible: true,
    key: "selectionReason",
    label: "Remark",
    placeholder: "Type here...",
    formOptions: {
      rules: [{ required: true, message: "Required" }],
    },
  });

  const renderModalContent = () => {
    return <div style={{ paddingBottom: 100 }}>
      <span style={{ color: '#111111', fontSize: 12, fontWeight: 600, paddingBottom: 8 }}>
        Reason
      </span>
      {selectionReason.decorator(<Input.TextArea autoSize={{ minRows: 8, maxRows: 14 }} />)}
    </div>;
  };

  const renderTitle = () => {
    return (
      <span style={{ color: '#111111', fontSize: 14, fontWeight: 600 }}>
        Reason for Bid selection
      </span>
    );
  }

  return (
    <Modal
      className={classes.modal}
      width="442px"
      visible={visible}
      closable={true}
      title={renderTitle()}
      onCancel={() => handleClose()}
      onOk={() => form.validateFields((err, val) => {
          if (!err) handleSubmit(selectionReason.value)}
      )}
      okText="Submit"
      cancelText="Cancel"
    >
      <div className={classes.content}>{renderModalContent()}</div>
    </Modal>
  );
};

export default React.memo(withStyles(styles)(Form.create({})(SEBidSelectionReasonModal)));
